"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnonymousCoder = void 0;
var _abstractCoder = require("./abstract-coder");
// Clones the functionality of an existing Coder, but without a localName
class AnonymousCoder extends _abstractCoder.Coder {
  constructor(coder) {
    super(coder.name, coder.type, undefined, coder.dynamic);
    this.coder = coder;
  }
  encode(writer, value) {
    return this.coder.encode(writer, value);
  }
  decode(reader) {
    return this.coder.decode(reader);
  }
}
exports.AnonymousCoder = AnonymousCoder;